/**
 * Generiert einen String der Laenge length aus dem characters seed
 *
 * @param {number} length - Die Laenge des zu generierende Strings
 * @param {string} [characters] - Der Seed
 */
function generateRandomString(length, characters = "abcdefghijklmnopqrstuvqxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    return Array(length)
        .fill(0)
        .map(it => characters[Math.floor(Math.random() * characters.length)])
        .join("")
}


function determineTextColor(backgroundColor) {
    // expects color from "window.computedStyle(elem).backgroundColor"
    let rgbMatch = backgroundColor.match(/\d+/g);
    const rgb = rgbMatch ? rgbMatch.map(Number) : null;
    return luminance(rgb[0], rgb[1], rgb[2]) > 0.5 ? 'black' : 'white';
}